import Vue from 'vue'

const state = {
  sistema: [],
  sistemas: [],
  sistemaEditar: [],
  sistemaVisualizar: [],
  clientIdNovo: '',
  clientKeyNovo: ''
}

const getters = {
  getSistema: state => {
    return state.sistema
  }
}

const mutations = {
  setSistema (state, data) {
    state.sistema = data
  },
  setSistemas (state, data) {
    state.sistemas = data
  },
  setSistemaEditar (state, data) {
    state.sistemaEditar = data
  },
  setClientId (state, data) {
    state.clientIdNovo = data
  },
  setClientKey (state, data) {
    state.clientKeyNovo = data
  }
}

const actions = {
  getSistemas (context, config) {
    if (!config.page) {
      config.page = 1
    }

    if (!config.limit) {
      config.limit = 200
    }

    Vue.http.get('api/sistema?length=' + config.limit + '&page=' + config.page).then(response => {
      context.commit('setSistemas', response.body.data.data)
    })
  },
  getSistema (context, id) {
    Vue.http.get('api/sistema/' + id).then(response => {
      context.commit('setSistemaEditar', response.data.data[0])
    })
  },
  getId (context) {
    Vue.http.get('api/sistema/gerarId').then(response => {
      context.commit('setClientId', response.data.data[0])
    })
  },
  getKey (context) {
    Vue.http.get('api/sistema/gerarKey').then(response => {
      context.commit('setClientKey', response.data.data[0])
    })
  },
  atualizarPermissoes (context) {
    context.commit('atualizaPermissoes')
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/sistema.js